module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.idea.id) ? _c('div', {
    staticClass: "cabinet",
    class: 'status_' + _vm.idea.status_id
  }, [_c('div', {
    staticClass: "cabinet-header"
  }, [_vm._l((_vm.getCategories()), function(cat) {
    return _c('router-link', {
      staticClass: "first-link-cabinet",
      attrs: {
        "to": {
          name: 'ideas-category',
          params: {
            category_id: cat.id
          }
        }
      }
    }, [_vm._v("\n            " + _vm._s(cat.title) + "\n        ")])
  }), _vm._v(" "), (_vm.dateToNow(_vm.idea.created) < 8) ? _c('span', {
    staticClass: "badge-new"
  }, [_vm._v("Новая")]) : _vm._e(), _vm._v(" "), (_vm.idea.likes >= 50) ? _c('span', {
    staticClass: "badge-popular"
  }, [_vm._v("Популярная")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "badge-status"
  }, [_vm._v(_vm._s(_vm.status))]), _vm._v(" "), (_vm.starrable) ? _c('span', {
    staticClass: "help-button",
    class: {
      'active-help-button': _vm.idea.starred
    },
    attrs: {
      "title": "Добавить в избранное"
    },
    on: {
      "click": function($event) {
        _vm.toggleStarred(_vm.idea)
      }
    }
  }, [_c('i', {
    staticClass: "ti-star"
  })]) : _vm._e(), _vm._v(" "), (_vm.editable) ? _c('span', {
    staticClass: "help-button trash",
    attrs: {
      "title": "Удалить"
    },
    on: {
      "click": function($event) {
        _vm.deleteIdea(_vm.idea)
      }
    }
  }, [_c('i', {
    staticClass: "ti-trash"
  })]) : _vm._e(), _vm._v(" "), (_vm.editable) ? _c('router-link', {
    staticClass: "redact",
    attrs: {
      "to": {
        name: 'idea-edit',
        params: {
          id: _vm.idea.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "ti-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()], 2), _vm._v(" "), _c('h2', {
    staticClass: "cabinet-title"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'idea',
        params: {
          id: _vm.idea.id
        }
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.idea.title) + "\n        ")])], 1), _vm._v(" "), _c('p', {
    class: ['cabinet-text', !_vm.isItMyPage() ? 'cabinet-text-crop' : ''],
    domProps: {
      "innerHTML": _vm._s(_vm.idea.description)
    }
  }), _vm._v(" "), (_vm.idea.admin_note.comment && _vm.idea.admin_note && _vm.idea.admin_note.id) ? _c('div', {
    staticClass: "moderator"
  }, [_c('span', {
    staticClass: "moderator-user"
  }, [_vm._v("Модератор")]), _vm._v(" "), _c('span', {
    staticClass: "moderator-name"
  }, [_vm._v(_vm._s(_vm.idea.admin_name || _vm.idea.admin_note.user.name || ''))]), _vm._v(" "), _c('span', {
    staticClass: "moderator-date"
  }, [_vm._v(_vm._s(_vm.date(_vm.idea.admin_note.created)))]), _vm._v(" "), _c('p', {
    staticClass: "moderator-text",
    domProps: {
      "innerHTML": _vm._s(_vm.idea.admin_note.comment)
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "cabinet-footer"
  }, [(_vm.idea.status_id > 1) ? _c('div', {
    staticClass: "cabinet-rates"
  }, [_c('span', {
    staticClass: "button-like cabinet-buttons",
    class: {
      'active-cabinet-buttons': _vm.idea.liked === 1
    },
    on: {
      "click": function($event) {
        _vm.toggleLike(_vm.idea, 1)
      }
    }
  }, [_c('i', {
    staticClass: "ti-thumb-up"
  }), _vm._v(" " + _vm._s(_vm.idea.likes) + "\n            ")]), _vm._v(" "), _c('span', {
    staticClass: "button-dislike cabinet-buttons",
    class: {
      'active-cabinet-buttons': _vm.idea.liked === 0
    },
    on: {
      "click": function($event) {
        _vm.toggleLike(_vm.idea, 0)
      }
    }
  }, [_c('i', {
    staticClass: "ti-thumb-down",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.idea.dislikes) + "\n            ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "cabinet-info"
  }, [(_vm.idea.status_id > 1) ? _c('div', {
    staticClass: "cabinet-comments"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'idea',
        params: {
          id: _vm.idea.id
        }
      }
    }
  }, [_c('span', {
    staticClass: "comments"
  }, [_vm._v("\n                        " + _vm._s(_vm.idea.comments) + "\n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "hide-mob"
  }, [_vm._v("\n                        " + _vm._s(' ' + _vm.numerable(_vm.idea.comments, ['комментарий', 'комментария', 'комментариев'])) + "\n                    ")])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "cabinet-user user-name"
  }, [(_vm.idea.user) ? _c('a', {
    staticClass: "shortname",
    attrs: {
      "href": ("https://amd.platformalp.ru/accounts/" + (_vm.idea.user.account_id)),
      "target": "_blank"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.idea.user.name ? ((_vm.idea.user.name) + ",") : '') + "\n                ")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.date(_vm.idea.created)) + "\n            ")])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01e79f56","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Idea.vue
// module id = 105
// module chunks = 0